import Link from "next/link"
import React from "react"
import CustomButton from "../../../../ui/atoms/Button"
import { EditorialLabel } from "../../../contents"

interface Props {
  onClick?: () => void
}

const NewUserPanel = ({ onClick }: Props) => {
  return (
    <>
      <EditorialLabel
        scope="account"
        id="new-user"
        variant="h4"
        className="pt-6"
      />
      <div className="mt-4 mb-4">
        <Link href="/account/register">
          <a onClick={onClick}>
            <CustomButton variant="outlined" fullWidth>
              <EditorialLabel scope="account" id="register" plainText />
            </CustomButton>
          </a>
        </Link>
      </div>
    </>
  )
}

export default NewUserPanel
